import BaseConfig from '@/config/base.js'

// mock本地调试
let useMock = false
let mockName = 'vava'
let mockLang = 'en'
const mockStrategies = {
  echo() { return mockName === 'echo' },
  joychat() { return mockName === 'joychat' },
  joyu() { return mockName === 'joyu' },
  kiko() { return mockName === 'kiko' },
  vava() { return mockName === 'vava' },
  vibeo() { return mockName === 'vibeo' },
  whonow() { return mockName === 'whonow' }
}

// 确保VUE_APP_CODE_STATE一定有值再用mock
// prettier-ignore
if (process.env.VUE_APP_CODE_STATE) {
  useMock = process.env.VUE_APP_CODE_STATE !== 'product' && process.env.VUE_APP_CODE_STATE !== 'test'
  mockName = process.env.VUE_APP_CODE_STATE !== 'product' ? mockName : 'vava'
  mockLang = process.env.VUE_APP_CODE_STATE !== 'product' ? mockLang : 'en'
}
// 未知环境
else {
  useMock = false
  mockName = 'vava',
  mockLang = 'en'
}

// 正式环境mockFlag一定得是false
export const mockFlag = useMock
export const mockApp = mockName
export const mockLangType = mockLang

// 区分包-包名
export function appNameFlag(type, val) {
  if (useMock) {
    return mockStrategies[type] ? mockStrategies[type]() : false
  }

  const packages = BaseConfig.apps[type]?.packages
  return packages ? packages.includes(val) : false
}

// 区分包-域名
export function domainNameFlag(type, val) {
  if (useMock) {
    return mockStrategies[type] ? mockStrategies[type]() : false
  }

  const hosts = BaseConfig.apps[type]?.hosts
  return hosts ? hosts.includes(val) : false
}
